var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronBigUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.29,16.71l-7.29-7.29-7.29,7.29-1.41-1.41L11.29,7.29h1.41l8,8-1.41,1.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronBigUp);
export default __webpack_public_path__ + "static/1768397567/media/icon-chevron-big-up.7c8bfc2d04c271c40b611b56fc7e569e.svg";
export { ForwardRef as ReactComponent };